import script from "./productOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./productOrder.vue?vue&type=script&setup=true&lang=js"

import "./productOrder.vue?vue&type=style&index=0&id=1af62b03&lang=less&scoped=true"

import exportComponent from "/disk2/var/jenkins/workspace/pre__cosmic-mall-h5-entry/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1af62b03"]])

export default __exports__